var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#777777;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#777777;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13.5,
    cy: 13.5,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.8,20.7h-5.4h-0.8h-0.1h-0.8H7.2v-1.9c0-0.2,0.1-0.3,0.3-0.4c0.7-0.3,2.6-1,3.8-1.4 c0.6-0.2,0.6-0.8,0.6-1.2c0-0.6-0.1-1-0.2-1.4c-0.1-0.3-0.3-0.7-0.3-1.2l0-0.2l-0.1-0.2c-0.1-0.1-0.3-0.4-0.4-1.1 c-0.1-0.6-0.1-0.7,0-0.8l0.1-0.2v0v0c0.1-0.4,0-1.4-0.1-2c-0.1-0.3,0-1,0.5-1.7c0.3-0.4,0.9-0.9,1.9-0.9h0.7 c0.9,0.1,1.5,0.4,1.9,0.9c0.5,0.6,0.5,1.4,0.5,1.7c-0.1,0.6-0.2,1.6-0.1,2l0,0l0,0l0,0.1v0c0,0.1,0.1,0.2,0,0.8 c-0.1,0.7-0.3,1-0.4,1.1l-0.1,0.2l0,0.2c0,0.4-0.2,0.9-0.3,1.2c-0.2,0.4-0.3,0.8-0.3,1.4c0,0.4,0,1,0.6,1.2c1.2,0.3,3.1,1,3.8,1.4 c0.3,0.1,0.4,0.4,0.4,0.5V20.7z M19.6,17.7c-0.8-0.4-2.7-1-3.9-1.4c-0.1,0-0.1,0-0.1-0.5c0-0.4,0.1-0.7,0.3-1 c0.1-0.3,0.3-0.9,0.4-1.4c0.2-0.2,0.4-0.6,0.6-1.5c0.1-0.7,0.1-1,0-1.2l0-0.1c0-0.2,0-1,0.1-1.7c0.1-0.5,0-1.4-0.6-2.3 c-0.4-0.5-1.1-1.1-2.5-1.2h-0.7c-1.3,0.1-2.1,0.7-2.5,1.2C10,7.5,9.9,8.5,10,9c0.1,0.7,0.2,1.5,0.1,1.7l0,0.1 c-0.1,0.2-0.2,0.5,0,1.2c0.2,0.8,0.4,1.2,0.6,1.5c0.1,0.5,0.2,1,0.4,1.4c0.1,0.2,0.2,0.6,0.2,1c0,0.4,0,0.4-0.1,0.5 c-1.2,0.4-3.2,1.1-3.9,1.4c-0.6,0.2-0.7,0.7-0.7,1.1v1.9c0,0.3,0.2,0.7,0.7,0.7h5.4h0.8h0.1h0.8h5.5c0.5,0,0.7-0.5,0.7-0.7v-1.9 C20.5,18.5,20.2,18,19.6,17.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcn);
export default __webpack_public_path__ + "static/media/people_icn.a8aafb7b994a9defa4d3c1e1a94fbb39.svg";
export { ForwardRef as ReactComponent };